<nz-modal [nzVisible]="visible" (nzVisibleChange)="visibleChange.emit($event)"
          [nzTitle]="showVerify() ? 'Verify your email' : 'Sign in to InExFlo'" [nzFooter]="null"
          (nzOnCancel)="close()">
  <ng-container *nzModalContent>

    @if (sessionExpiry) {
      <nz-alert
        nzType="warning"
        nzMessage="Session expired"
        nzDescription="Your session expired due to inactivity. Please log in again to continue where you left off."
        style="margin-bottom:1rem">
      </nz-alert>
    }

    @if (showVerify()) {
      <!-- Verification code step -->
      @if (error()) {
        <nz-alert nzType="error" [nzMessage]="error()!" style="margin-bottom:0.75rem"></nz-alert>
      }
      <p style="color:#6b7280;font-size:0.9rem;margin-bottom:1rem">
        We've sent a 6-digit verification code to <strong>{{ verifyEmail() }}</strong>.
        It expires in 20 minutes.
      </p>
      <form (ngSubmit)="submitVerification()" style="display:flex;flex-direction:column;gap:1rem">
        <div>
          <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Verification code</label>
          <input nz-input type="text" [(ngModel)]="verifyCode" name="verifyCode"
                 maxlength="8" placeholder="000000" required
                 autocomplete="one-time-code" inputmode="numeric"
                 style="width:100%;font-size:1.5rem;letter-spacing:8px;text-align:center" />
        </div>
        <button nz-button nzType="primary" type="submit" [nzLoading]="loading()" [disabled]="loading()" style="width:100%">Verify</button>
      </form>
      <div style="text-align:center;margin-top:0.75rem">
        <button nz-button nzType="link" nzSize="small" [nzLoading]="resending()" (click)="resendCode()">
          Resend code
        </button>
      </div>
    } @else {

    <nz-tabs [nzSelectedIndex]="activeTabIndex()" (nzSelectedIndexChange)="setTab($event)">
      <nz-tab nzTitle="Log in">
        @if (error()) {
          <nz-alert nzType="error" [nzMessage]="error()!" style="margin-bottom:0.75rem"></nz-alert>
        }
        <form (ngSubmit)="login()" style="display:flex;flex-direction:column;gap:1rem;margin-top:0.75rem">
          <div>
            <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Email</label>
            <input nz-input type="email" [(ngModel)]="loginEmail" name="loginEmail"
                   autocomplete="email" required style="width:100%" />
          </div>
          <div>
            <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Password</label>
            <nz-input-group [nzSuffix]="loginEyeTpl">
              <input [type]="showLoginPwd ? 'text' : 'password'" nz-input
                     [(ngModel)]="loginPassword" name="loginPassword"
                     autocomplete="current-password" required />
            </nz-input-group>
            <ng-template #loginEyeTpl>
              <span nz-icon [nzType]="showLoginPwd ? 'eye-invisible' : 'eye'"
                    style="cursor:pointer" (click)="showLoginPwd = !showLoginPwd"></span>
            </ng-template>
          </div>
          <button nz-button nzType="primary" type="submit" [nzLoading]="loading()" [disabled]="loading()" style="width:100%">Log in</button>
        </form>
      </nz-tab>

      <nz-tab nzTitle="Register">
        @if (error()) {
          <nz-alert nzType="error" [nzMessage]="error()!" style="margin-bottom:0.75rem"></nz-alert>
        }
        <form (ngSubmit)="register()" style="display:flex;flex-direction:column;gap:1rem;margin-top:0.75rem">
          <div>
            <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Email</label>
            <input nz-input type="email" [(ngModel)]="regEmail" name="regEmail"
                   autocomplete="email" required style="width:100%" />
          </div>
          <div>
            <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Password</label>
            <nz-input-group [nzSuffix]="regEyeTpl">
              <input [type]="showRegPwd ? 'text' : 'password'" nz-input
                     [(ngModel)]="regPassword" name="regPassword"
                     autocomplete="new-password" required />
            </nz-input-group>
            <ng-template #regEyeTpl>
              <span nz-icon [nzType]="showRegPwd ? 'eye-invisible' : 'eye'"
                    style="cursor:pointer" (click)="showRegPwd = !showRegPwd"></span>
            </ng-template>
          </div>
          <div>
            <label style="display:block;margin-bottom:0.25rem;font-size:0.85rem">Confirm password</label>
            <nz-input-group [nzSuffix]="regConfirmEyeTpl">
              <input [type]="showRegConfirm ? 'text' : 'password'" nz-input
                     [(ngModel)]="regConfirm" name="regConfirm"
                     autocomplete="new-password" required />
            </nz-input-group>
            <ng-template #regConfirmEyeTpl>
              <span nz-icon [nzType]="showRegConfirm ? 'eye-invisible' : 'eye'"
                    style="cursor:pointer" (click)="showRegConfirm = !showRegConfirm"></span>
            </ng-template>
          </div>
          <button nz-button nzType="primary" type="submit" [nzLoading]="loading()" [disabled]="loading()" style="width:100%">Create account</button>
        </form>
      </nz-tab>
    </nz-tabs>

    }

  </ng-container>
</nz-modal>
